import { Button, Lock } from '@airtm/airtm-ui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { LOCAL_STORAGE } from '@constants';

function Enable2FA() {
  const history = useHistory();
  const { t } = useTranslation('ENTERPRISE_SIGNUP');

  const onContinue = (path) => {
    localStorage.removeItem(LOCAL_STORAGE.SHOW_ENABLE_2FA_SCREEN);
    history.push(path);
  };

  return (
    <div className="mt-9">
      <Lock className="d-block text--black" size="48" />
      <h1 className="mt-5">{t('2FA_TITLE')}</h1>
      <h5 className="font-weight--regular text--gray-6 my-5">{t('2FA_DESCRIPTION')}</h5>
      <div className="d-flex">
        <Button variant="secondary" className="mr-5" onClick={() => onContinue('/')}>
          {t('2FA_SECONDARY_BUTTON')}
        </Button>
        <Button className="" onClick={() => onContinue('/settings/security')}>
          {t('2FA_PRIMARY_BUTTON')}
        </Button>
      </div>
    </div>
  );
}

export default Enable2FA;
